import { unsafeCSS } from "lit";
import { customElement } from "lit/decorators.js";
import EkoElement from "@/utilities/element";
import style from "./admin-background-pattern.css?inline";

@customElement("eko-admin-background-pattern")
class AdminBackgroundPattern extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(style)];
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-admin-background-pattern": AdminBackgroundPattern;
  }
}

export default AdminBackgroundPattern;
